const state = {
  notification: null, 
};

const mutations = {
  setNotification(state, notification) {
    state.notification = notification;
  },
};

const actions = {
  setNotification({ commit }, notification) {
    commit('setNotification', notification); 
  },
};

const getters = {
  notification: (state) => state.notification, 
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
